// extracted by mini-css-extract-plugin
export default {"contentContainer":"OrdersPanelContent_contentContainer__HEwev","productLineTabsContainer":"OrdersPanelContent_productLineTabsContainer__msanm"};